import React, { useContext, useEffect, useState } from 'react';
import {
    Cards, CardsContent, CloseButton, CardsImage, CardsTitle, CardsText
} from './CardsModal.styles';
import { Button } from 'view/components/common';
import IMAGES from 'assets/images';
import { ModalContext } from 'core/modal';

interface Props 
{
    onRedirect : () => void;
}

export const CardsModal: React.FunctionComponent<Props> = ({
    onRedirect
}) => 
{
    const { close } = useContext(ModalContext);
    const [ isLoading, setIsLoading ] = useState<boolean>(true);
    useEffect(() => 
    {
        setIsLoading(false);
    }, [ setIsLoading ]);

    return (
        <Cards>
            <CardsContent className={isLoading ? '' : 'fade-in'}>
                <CloseButton onClick={close} />
                <CardsImage src={IMAGES.halalCards} alt="Halal Cards" />
                <CardsTitle>
                    You Will Now Be Redirected to KOHO to Sign Up for the Halal Card.
                </CardsTitle>
                <CardsText>
                    Manzil has partnered with Koho to provide you with a halal prepaid card.
                    Once the new window opens, complete the signup process with Koho in
                    order to create your prepaid card account and access the service.
                </CardsText>
                <Button
                    onClick={onRedirect}
                    type={'button'}
                    title="Continue to KOHO"
                    arrowCss={''}
                    css={'height: 2.2rem; width: auto; padding: 0 2rem; float: right;'}
                />
            </CardsContent>
        </Cards>
    );
};
